import theme from 'live/services/theme'
import styled, { StyledComponent } from 'styled-components'

export const Content = styled.div<{ showGroupId: boolean }>`
    .well-selector {
        right: -14px;
    }
    .well-selector .Select,
    .well-selector input.form-control {
        margin-top: 8px;
        margin-bottom: 5px;
    }
    .sisp-instances {
        margin: 3px 0px;
    }
    .send-to-sisp {
        margin: 3px 0px;
    }

    .sisp-result {
        padding-top: 16px;
    }

    .well-selector .small-footer {
        padding-bottom: 7px;
        padding-top: 6px;
        border: unset;
        button {
            height: 24px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    i.fa.fa-check-circle {
        margin-bottom: 10px;
    }

    .well-selector {
        height: ${({ showGroupId }) => `${showGroupId ? '520' : '220'}px`};
        width: 320px;
        z-index: 10;

        .sisp-result-container {
            margin-top: 0px;
        }
    }
`

export const MultSelect = styled.div`
    border: unset !important;
    .Select-menu {
        height: 100px;
    }
    i {
        margin-left: 5px;
    }
    .sisp-semi-bold-title {
        font-weight: ${theme['semi-bold']};
    }
    .grouptest-toggle {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        margin: 9px 0px;
        align-items: baseline;
        a {
            margin-right: 20px;
        }
    }

    .form-group {
        margin-bottom: 5px;
    }
    span {
        margin-bottom: 5px;
    }

    .Select.has-value.is-clearable.is-searchable.Select--multi .Select-control .Select-multi-value-wrapper {
        max-height: 90px;
        overflow-y: scroll;
        width: 100%;
        flex-direction: row;
        flex-wrap: wrap;
        .Select-value {
            display: flex;
            align-items: center;
        }
    }
`

export const ListErrorTests = styled.div`
    height: fill;
    padding: 5px;
    text-align: left;
    max-height: 270px;
    label i.fa-exclamation-triangle {
        font-size: 16px !important;
    }
    .test-error-container {
        margin: 12px 0px;
        i {
            font-size: 12px !important;
        }
    }
`
export const ErrorTestsContainer = styled.div`
    border: 1px solid #bac0cb;
    margin: 10px;
    max-height: 310px;
    overflow-y: scroll;
    label.title {
        padding: 5px 0px;
        border-bottom: 1px solid #bac0cb;
        i {
            margin-right: 5px;
        }
    }
`

export const TimeRangeContainer = styled.div`
    div {
        display: flex;
        flex-direction: column;
        height: auto;
    }
`
export const OptionContainer = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 70px;
    width: 100%;
    div {
        display: flex;
        justify-content: space-between;
        div {
            flex-direction: column;
            label {
                margin-right: 5px;
            }
        }
    }
    div {
        i {
            cursor: pointer;
            color: #37a3ef;
        }
    }
    span {
        font-weight: normal;
        color: #868695;
        b {
            color: #606a80;
        }
    }
    .time-range__text {
        flex-direction: row;
        width: 100%;
        padding: 0;
        div {
            flex-direction: row;
            padding: 0;
        }
        div.time-range__begin {
            span:nth-child(1) {
                color: #28334a;
            }
        }
        div.time-range__end {
            span:nth-child(2) {
                color: #28334a;
            }
        }
    }
`

export const ButtonContainer = styled.div`
    button {
        line-height: 10px;
    }
    .btn-footer-container {
        display: flex;
        flex-direction: row;
    }
`

export const AuthContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 590px;

    input {
        width: 238px;
    }

    .input-password {
        width: 238px !important;
        border: none !important;

        input {
            border: 1px solid #ccc !important;
        }
    }
`
